export { LDScrollTo };
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

class LDScrollTo {

  constructor( duration, offsetY ) {
		this.duration = 0.5;
		this.offsetY = 60;
    
    if( duration !== undefined ){
      this.duration = duration;
    }

    if( offsetY !== undefined ){
      this.offsetY !== offsetY;
    }

    // If a link's href is within the current page, scroll to it instead
    document.querySelectorAll('a[href]').forEach(aLink => {
      
      aLink.addEventListener('click', clickEvent => {
        this.scrollToHash( this.getSamePageAnchor( aLink ), clickEvent );
      });

    });

    // Scroll to the element in the URL's hash on load
    this.scrollToHash(window.location.hash);
  }
  
  // Detect if a link's href goes to the current page
  getSamePageAnchor (link) {
    if (
      link.protocol !== window.location.protocol ||
      link.host !== window.location.host ||
      link.pathname !== window.location.pathname ||
      link.search !== window.location.search
    ) {
      return false;
    }

    return link.hash;
  }

  // Scroll to a given hash, preventing the event given if there is one
  scrollToHash( hash, event ) {
    const elem = hash ? document.querySelector(hash) : false;
    
    if(elem) {
      if(event) event.preventDefault();
      gsap.to( window, {
        scrollTo: {
          y: elem,
          offsetY: this.offsetY
        },
        duration: this.duration,
        onComplete: function(){
          window.location.hash = hash;
        }
      });
    }
  }

}